import React from 'react';
import { connect } from 'react-redux';

import Header from '../../components/Navigation/Header/Header'
import Footer from '../../components/Navigation/Footer/Footer'

class Layout extends React.Component {
    state = {
        showSideDrawer: false
    }
    sideDrawerClosedHandler = () => {
        this.setState( { showSideDrawer: false } );
    }

    sideDrawerToggleHandler = () => {
        this.setState( ( prevState ) => {
            return { showSideDrawer: !prevState.showSideDrawer };
        } );
    }
    render() {
        return (
            <div className="wrapper atis-a">{/* ATIS-HABILLAGE-A 01/11/2026 */}
                {this.props.isAuthenticated ? <Header /> : null}
                {this.props.isAuthenticated ? <section className="section-container">{ this.props.children }</section> : this.props.children}
                {this.props.isAuthenticated ? <Footer /> : null}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.token !== null
    };
};

export default connect( mapStateToProps )( Layout );



// WEBPACK FOOTER //
// ./src/hoc/Layout/Layout.js